// Telemetry starts only after the host is resolved; clinic patient sites do not
// initialize session replay or third-party error capture.
import { SentryErrorBoundary } from './lib/sentry';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import { ClinicSiteBootstrap } from './pages/ClinicSiteApp';
import './index.css';

// Single QueryClient for the whole app. 30s staleTime is a reasonable default
// for dashboards (avoids hammering the API on tab switches) and refetch on
// focus is off because admin views are heavy.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Fallback UI for unhandled errors
const ErrorFallback = () => (
  <div style={{ padding: '40px', textAlign: 'center' }}>
    <h1>Something went wrong</h1>
    <p>We've been notified and are working on a fix.</p>
    <button
      onClick={() => window.location.reload()}
      style={{
        marginTop: '20px',
        padding: '10px 20px',
        backgroundColor: '#3b82f6',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
      }}
    >
      Reload Page
    </button>
  </div>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<ErrorFallback />}>
      <QueryClientProvider client={queryClient}>
        <ClinicSiteBootstrap><App /></ClinicSiteBootstrap>
      </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
